import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "type"],
    _excluded2 = ["children", "type"],
    _excluded3 = ["type"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { jsx } from "react/jsx-runtime";
import { createElement } from "react";
import { useComponentsContext } from "./BlocksRenderer.mjs";
import { Text } from "./Text.mjs";
var voidTypes = ["image"];

var augmentProps = function augmentProps(content) {
  var childrenNodes = content.children,
      type = content.type,
      props = _objectWithoutProperties(content, _excluded);

  if (type === "code") {
    var getPlainText = function getPlainText(children) {
      return children.reduce(function (currentPlainText, node) {
        if (node.type === "text") {
          return currentPlainText.concat(node.text);
        }

        if (node.type === "link") {
          return currentPlainText.concat(getPlainText(node.children));
        }

        return currentPlainText;
      }, "");
    };

    return _objectSpread(_objectSpread({}, props), {}, {
      plainText: getPlainText(content.children)
    });
  }

  return props;
};

var Block = function Block(_ref) {
  var content = _ref.content;

  var childrenNodes = content.children,
      type = content.type,
      props = _objectWithoutProperties(content, _excluded2);

  var _useComponentsContext = useComponentsContext(),
      blocks = _useComponentsContext.blocks,
      missingBlockTypes = _useComponentsContext.missingBlockTypes;

  var BlockComponent = blocks[type];

  if (!BlockComponent) {
    if (!missingBlockTypes.includes(type)) {
      console.warn("[@strapi/block-react-renderer] No component found for block type \"".concat(type, "\""));
      missingBlockTypes.push(type);
    }

    return null;
  }

  if (voidTypes.includes(type)) {
    return /* @__PURE__ */jsx(BlockComponent, _objectSpread({}, props));
  }

  var augmentedProps = augmentProps(content);
  return /* @__PURE__ */jsx(BlockComponent, _objectSpread(_objectSpread({}, augmentedProps), {}, {
    children: childrenNodes.map(function (childNode, index) {
      if (childNode.type === "text") {
        var _type = childNode.type,
            childNodeProps = _objectWithoutProperties(childNode, _excluded3);

        return /* @__PURE__ */createElement(Text, _objectSpread(_objectSpread({}, childNodeProps), {}, {
          key: index
        }));
      }

      return /* @__PURE__ */jsx(Block, {
        content: childNode
      }, index);
    })
  }));
};

export { Block };